function waitForGtag(timeoutMs = 1500) {
    return new Promise((resolve) => {
        const start = Date.now();
        const timer = setInterval(() => {
            if (typeof window !== "undefined" && typeof window.gtag === "function") {
                clearInterval(timer);
                resolve(true);
                return;
            }
            if (Date.now() - start > timeoutMs) {
                clearInterval(timer);
                resolve(false);
            }
        }, 50);
    });
}

async function gtagGet(targetId, fieldName, timeoutMs = 1500) {
    // SSR-safe
    if (typeof window === "undefined") return null;

    const ok = await waitForGtag(timeoutMs);
    if (!ok) return null;

    return new Promise((resolve) => {
        try {
            window.gtag("get", targetId, fieldName, (value) => {
                resolve(value ?? null);
            });
        } catch (e) {
            resolve(null);
        }
    });
}

/**
 * Возвращает GA4-контекст для серверной отправки purchase:
 * - client_id обязателен для MP (web)
 * - session_id + engagement_time_msec нужны для отображения в Realtime
 */
export async function getGa4Context(measurementId) {
    if (!measurementId) {
        return { client_id: null, session_id: null, session_number: null };
    }

    const [client_id, session_id, session_number] = await Promise.all([
        gtagGet(measurementId, "client_id"),
        gtagGet(measurementId, "session_id"),
        gtagGet(measurementId, "session_number"),
    ]);

    return { client_id, session_id, session_number };
}
